/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const CAppelFonctionNVar = require('./CAppelFonctionNVar')
module.exports = CAppelFonctionComplexeNVar
/**
 * Objet d'un arbre binaire de calcul représentant un appel de fonction complexe utilisateur
 * à n variables.
 * @constructor
 * @extends CAppelFonctionNVar
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {Integer} nbVar : Le nombre de variables de la fonction
 * @param {CFoncNVar} fonctionAssociee : La fonction appliquée à l'opérande.
 * @param {Array} operande : Tableau de CCb représentant les opérandes.
 * @returns {CAppelFonctionComplexeNVar}
 */
function CAppelFonctionComplexeNVar (listeProprietaire, nbVar, fonctionAssociee, operande) {
  CAppelFonctionNVar.call(this, listeProprietaire, nbVar, fonctionAssociee, operande);
}
CAppelFonctionComplexeNVar.prototype = new CAppelFonctionNVar();
CAppelFonctionComplexeNVar.prototype.constructor = CAppelFonctionComplexeNVar;
CAppelFonctionComplexeNVar.prototype.superClass = "CAppelFonctionNVar";
CAppelFonctionComplexeNVar.prototype.className = "CAppelFonctionComplexeNVar";


CAppelFonctionComplexeNVar.prototype.getClone = function(listeSource, listeCible) {
  var operandeClone = new Array(this.nbVar);
  for (var i = 0; i < this.nbVar;i++)
    operandeClone[i] = this.operande[i].getClone(listeSource, listeCible);
  var ind1 = listeSource.indexOf(this.fonctionAssociee);
  return new CAppelFonctionComplexeNVar(listeCible, this.nbVar, listeCible.get(ind1, "CAppelFonctionComplexeNVar"),
    operandeClone);
};

CAppelFonctionComplexeNVar.prototype.getCopie = function() {
  var operandeCopie = new Array(this.nbVar);
  for (var i = 0; i < this.nbVar; i++) operandeCopie[i] = this.operande[i].getCopie();
  return new CAppelFonctionComplexeNVar(this.listeProprietaire, this.nbVar, this.fonctionAssociee, operandeCopie);
};

CAppelFonctionComplexeNVar.prototype.calculAvecValeursRemplacees = function() {
  var nbvar = this.fonctionAssociee.nombreVariables();
  var tabcal = new Array(this.fonctionAssociee.nombreVariables());
  for (var i = 0; i < nbvar; i++) {
    tabcal[i] = this.operande[i].calculAvecValeursRemplacees();
  }
  return new CAppelFonctionComplexeNVar(this.listeProprietaire, nbvar, this.fonctionAssociee, tabcal);
};



// WEBPACK FOOTER //
// ./src/objets/CAppelFonctionComplexeNVar.js